const tables = [
  {
    name: "Name",
  },
  {
    name: "Email",
  },
  {
    name: "Phone",
  },
  {
    name: "Country",
  },
  {
    name: "Login",
  },
  {
    name: "Logout",
  },
];

export default tables;
